import Quizdata from "components/showQuizData/showQuizData";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function ShowQuiz() {
    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        if (!id) {
            navigate('/');
        }
    }, [id, navigate]);

    return (
        <div className="show-quiz-container">
            <Quizdata id={id} />
        </div>
    );
}

